import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["line"]
    static values = {
        stepKey: String,
        delay: { type: Number, default: 150 },
        initialDelay: { type: Number, default: 100 }
    }

    connect() {
        // Listen for step-shown event
        this.handleStepShown = this.handleStepShown.bind(this)
        window.addEventListener('onboarding:step-shown', this.handleStepShown)
    }

    disconnect() {
        window.removeEventListener('onboarding:step-shown', this.handleStepShown)
    }

    handleStepShown(event) {
        // Only animate if this is the step being shown
        if (event.detail.stepKey === this.stepKeyValue) {
            this.animateLines()
        }
    }

    animateLines() {
        // Reset all lines to hidden state first
        this.lineTargets.forEach(line => {
            line.classList.remove("fade-in-visible")
            line.classList.add("fade-in-hidden")
        })

        // Force a reflow
        void this.element.offsetWidth

        // Now animate each line with staggered delays
        this.lineTargets.forEach((line, index) => {
            setTimeout(() => {
                line.classList.remove("fade-in-hidden")
                line.classList.add("fade-in-visible")
            }, this.initialDelayValue + (index * this.delayValue))
        })
    }
}
